// Topbar.js
import React, { useState } from 'react';
import { useEditor } from '@craftjs/core';
import { Box, Button as MaterialButton } from '@mui/material';
import { useQwanta } from "qwanyx";

export const Topbar = () => {
  const { actions, query, enabled, canUndo, canRedo } = useEditor((state, query) => ({
    enabled: state.options.enabled,
    canUndo: state.options.enabled && query.history.canUndo(),
    canRedo: state.options.enabled && query.history.canRedo()
  }));

  const [savedState, setQwanta] = useQwanta("card");
  const [cardId] = useQwanta("_id");
  const [copied, setCopied] = useState(false);

  const saveToCard = () => {
    const json = query.serialize();
    setQwanta("card", json);
  };

  const copyId = async () => {
    await navigator.clipboard.writeText(cardId);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Box p={2} bgcolor="#cbe8e7" borderBottom="1px solid #ccc">
      <Box display="flex" flexDirection="column" gap={1}>
        
        {cardId && (
          <MaterialButton 
            variant="outlined" 
            size="small"
            onClick={copyId}
            fullWidth
          >
            {copied ? 'ID Copied!' : cardId}
          </MaterialButton>
        )}
        
        <label style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <input 
            type="checkbox" 
            checked={enabled} 
            onChange={(e) => actions.setOptions(options => options.enabled = e.target.checked)} 
            style={{ marginRight: '5px' }}
          />
          Enable Editor
        </label>
        
        <Box display="flex" gap={1} mb={1}>
          <MaterialButton 
            variant="outlined" 
            size="small"
            disabled={!canUndo}
            onClick={() => actions.history.undo()}
            fullWidth
          >
            Undo
          </MaterialButton>
          <MaterialButton 
            variant="outlined" 
            size="small"
            disabled={!canRedo}
            onClick={() => actions.history.redo()}
            fullWidth
          >
            Redo
          </MaterialButton>
        </Box>
        
        <Box display="flex" gap={1} mb={1}>
          <MaterialButton 
            variant="outlined" 
            size="small"
            onClick={saveToCard}
            fullWidth
          >
            Save
          </MaterialButton>
        </Box>
      </Box>
    </Box>
  );
};

export default Topbar;